<template>
  <div class="fair-survey-step">
    <div class="fair-survey-step__head">
      <h2 class="fair-survey-step__title">
        {{ step.title }}
      </h2>
      <p
        v-if="step.subtitle"
        class="fair-survey-step__subtitle"
      >
        {{ step.subtitle }}
      </p>
    </div>

    <div class="look-step__fields">
      <div
        v-for="field in step.fields"
        :key="field.id"
        class="look-step__field"
      >
        <span class="look-step__label">{{ field.label }}</span>

        <FairInputText
          v-if="field.type === 'input'"
          v-model="fieldValues[field.id]"
          :placeholder="field.placeholder || ''"
          @update:model-value="() => updateField(field.id)"
        />

        <FairDropdown
          v-else-if="field.type === 'select'"
          v-model="fieldValues[field.id]"
          :options="(field.options ?? []).map((option) => ({
            key: option.value,
            label: option.label,
          }))"
          :placeholder="field.placeholder || 'Выберите'"
          show-radio
          @update:model-value="() => updateField(field.id)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { FairDropdown } from '@/ui/primitives/FairDropdown'
import { FairInputText } from '@/ui/primitives/FairInputText'
import { useLookModal } from '@/features/look/store'
import type { LookStep } from '@/features/look/types/look-config'

interface Props {
  step: LookStep & { type: 'dynamic_form' }
}

const props = defineProps<Props>()
const lookStore = useLookModal()

const fieldValues = ref<Record<string, any>>({})

function updateField(fieldId: string) {
  const fieldKey = `${props.step.id}_${fieldId}`
  lookStore.updateLookData(fieldKey, fieldValues.value[fieldId])
}

onMounted(() => {
  const data = lookStore.lookModal.lookData
  
  // Загружаем сохраненные значения для всех полей
  props.step.fields.forEach(field => {
    const fieldKey = `${props.step.id}_${field.id}`
    const savedValue = data[fieldKey]
    fieldValues.value[field.id] = savedValue || null
  })
})
</script>

<style scoped>
.look-step__fields {
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
}

.look-step__field {
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
}

.look-step__label {
  font-family: var(--font-display);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--color-text-muted);
}
</style>
